import {Basic} from "./Basic";

export class Load
{
    static post(href, myData, base='/')
    {
        document.documentElement.classList.add('w__waiting');
        myData.url = href;
        myData.time = new Date().getTime();

        return new Promise((resolve, reject) =>
        {
            const myRequest = new XMLHttpRequest();
            myRequest.timeout = 120000;
            myRequest.onreadystatechange = () =>
            {
                if(myRequest.readyState === 4)
                {
                    document.documentElement.classList.remove('w__waiting');
                    if(myRequest.status === 200 && myRequest.response)
                    {
                        if(myRequest.response['status'] === true)
                        {
                            resolve(myRequest.response);
                        }
                        else
                        {
                            reject(myRequest.response);
                        }
                    }
                    else
                    {
                        reject('Empty response. Status: ' + myRequest.status);
                    }
                }
            };

            myRequest.ontimeout = () =>
            {
                document.documentElement.classList.remove('w__waiting');
                reject('Request timed out. Network problems?');
            };

            myRequest.open('POST',base + 'index.php');
            myRequest.setRequestHeader('Content-Type','application/x-www-form-urlencoded; charset=utf-8');
            myRequest.setRequestHeader('Accept','application/json');
            myRequest.responseType = 'json';
            myRequest.send('json=' + encodeURIComponent(JSON.stringify(myData)));
        });
    }

    static async upload(fileObject, prefix, statusEl)
    {
        let ok = true,
            chunkSize = 1048576; // 1 MB;

        if(fileObject.size < 131072) // 128 kB
        {
            chunkSize = 65536; // 64kB
        }
        else if(fileObject.size < 524288) // 512 kB
        {
            chunkSize = 131072; // 128 kB
        }
        else if(fileObject.size < 1048576) // 1 MB
        {
            chunkSize = 262144; // 256 kB
        }
        else if(fileObject.size < 4194304) // 4 MB
        {
            chunkSize = 524288; // 512 kB;
        }

        document.documentElement.classList.add('w__waiting');

        let startByte = 0,
            endByte = chunkSize,
            fileParts = [],
            fileInfo =
                {
                    fileName: fileObject.name,
                    fileSize: fileObject.size,
                    partCount: 0,
                    uploadedBytes: 0,
                    statusEl: statusEl
                };

        fileInfo.partCount = Math.ceil(fileInfo.fileSize / chunkSize);

        for(let k=0; k<fileInfo.partCount; k++)
        {
            fileParts[k] = fileObject.slice(startByte, endByte);
            startByte = endByte;
            endByte = startByte + chunkSize;
        }

        // free memory
        fileObject = undefined;

        // start actual upload
        for(let partNo=0; partNo<fileInfo.partCount; partNo++)
        {
            try
            {
                fileInfo.uploadedBytes = await Load.upload_part(prefix, partNo, fileParts[partNo], fileInfo);
                fileParts[partNo] = false;
            }
            catch(error)
            {
                console.error(error);
                ok = false;
            }
        }

        document.documentElement.classList.remove('w__waiting');
        fileParts = undefined;
        fileInfo = undefined;

        return ok;
    }

    static async upload_part(filePrefix, partNo, part, fileInfo)
    {
        return new Promise((resolve, reject) =>
        {
            const fd = new FormData();
            fd.append('f','upload');
            fd.append('fileName', fileInfo.fileName);
            fd.append('filePrefix', filePrefix);
            fd.append('partNo', partNo);
            fd.append('partCount', fileInfo.partCount);
            fd.append('part', part);

            const myRequest = new XMLHttpRequest();
            myRequest.upload.addEventListener('progress',e =>
            {
                if(e.lengthComputable)
                {
                    let percent = Math.round((fileInfo.uploadedBytes + e.loaded) * 100 / fileInfo.fileSize);
                    if(percent > 100)
                    {
                        percent = 100;
                    }
                    if(fileInfo.statusEl)
                    {
                        fileInfo.statusEl.textContent = percent.toString() + ' %';
                    }
                }
            }, false);

            myRequest.addEventListener('load',e =>
            {
                const r = e.target['response'];

                // partial upload ok
                if(r === 'OK')
                {
                    fileInfo.uploadedBytes += part.size;
                    resolve(fileInfo.uploadedBytes);
                }
                else
                {
                    reject('Upload error');
                }

            }, false);

            myRequest.open('POST',Basic.base + 'upload.php');
            myRequest.setRequestHeader('Accept','text/html');
            myRequest.responseType = 'text';
            myRequest.send(fd);
        });
    }
}